import { useEffect, useState } from "react";

export interface ContentState<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
}

export function useContent<T>(key: string, load: () => Promise<T>): ContentState<T> {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;

    setLoading(true);
    setError(null);

    load()
      .then((value) => {
        if (!active) {
          return;
        }

        setData(value);
      })
      .catch((reason: unknown) => {
        if (!active) {
          return;
        }

        const message = reason instanceof Error ? reason.message : String(reason);
        setError(message);
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [key]);

  return { data, loading, error };
}
